import type { ReactNode } from 'react';
import { t } from '../../i18n';

/**
 * A message over the board that goes as soon as it is tapped, anywhere on it or on its ×, so it
 * never stays in the way of what it is about.
 */
export function Toast({
  children,
  error = false,
  onClose,
}: {
  children: ReactNode;
  error?: boolean;
  onClose: () => void;
}) {
  return (
    <p
      className={`notice notice-dismissible${error ? ' notice-error' : ''}`}
      role="alert"
      onClick={onClose}
    >
      <span className="notice-text">{children}</span>
      <button
        type="button"
        className="notice-close"
        aria-label={t('action.close')}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
          <path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>
    </p>
  );
}
